import { render, staticRenderFns } from "./SectionTitleEditor.vue?vue&type=template&id=7ff3e22a"
import script from "./SectionTitleEditor.vue?vue&type=script&lang=ts"
export * from "./SectionTitleEditor.vue?vue&type=script&lang=ts"
import style0 from "./SectionTitleEditor.vue?vue&type=style&index=0&id=7ff3e22a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports